import { r, r1, bf, gems, staticContent, arvato, CONTENT_TYPES } from "./apiBase";
import config from "../temp/config";
import "./api.jsdoc";
const api = {
  pages: {
    openposition: r("GET openpositiondata"),
    stories: r("POST stories")
  },
  colab: {
    get: r("GET colab/list")
  },
  subjecttype: {
    get: r("GET subjecttype")
  },
  caseInfo: {
    add: r("POST case/caseInfo"),
    list: r("GET case/accountCaseList"),
    detail: r("GET case/accountCaseInfo"),
    update: r("POST case/updateAccountCaseInfo"),
    testDriveCaseInfo: r("POST case/testDriveCaseInfo"),
    comparisonTool: r("POST case/comparisonTool"),
    accountAddInfo: r("POST case/AccountAddInfo"),
    b2bform: r("POST case/b2bform"),
    changeCaseStatus: r("POST case/changeCaseStatus")
  },
  areaInterest: {
    list: r("GET areaInterest/list/{language}"),
    accountAreaOfInterest: r("GET areaInterest/accountAreaOfInterest/{language}"),
    update: r("POST areaInterest/updateAccountAreaOfInterest")
  },
  country: {
    list: r("POST country/list"),
    get: r("GET country/{key}"),
    language: r("POST country/language")
  },
  language: r("GET language/{key}"),
  dpp: r("GET dpp/{itemId}"),
  bind: r("POST consent/bind"),
  unbind: r("POST consent/unbind"),
  route: {
    pagematch: r("GET pagematch")
  },
  Comparison: {
    create: gems("POST Leads/createComparison")
  },
  user: {
    login: r("POST login"),
    checklogin: r("POST checklogin"),
    update: gems("POST user/update"),
    addBankCard: gems("POST user/add-bank-card"),
    /**
     * @return {Promise<GEMSResponse<Array.<BankCard>>>}
     */
    getBankCard: gems("GET user/get-bank-card"),
    deleteBankCard: gems("POST user/delete-bank-card"),
    updateBankCard: gems("POST user/update-bank-card"),
    activeCard: {
      change: gems("POST user/change-card-pay"),
      transaction: gems("POST user/change-card-pay/transaction")
    },
    membership: {
      update: gems("POST user/membership/update")
    },
    promotion: gems("POST user/promotion"),
    upload: gems("POST user/upload", CONTENT_TYPES.file),
    countrylang: {
      update: gems("POST user/countrylang/update")
    },
    mobile: {
      update: gems("POST user/mobile/update")
    },
    vehicle: {
      stock: {
        subscribe: gems("POST User/vehicle/stock/subscribe")
      }
    },
    identity: {
      get: gems("POST user/detail-by-account/identity"),
      update: gems("POST user/update/identity")
    }
  },
  email: {
    check: gems("GET user/email/check/{email}"),
    update: gems("POST user/email/update"),
    getUser: gems("GET user/account/{email}")
  },
  account: {
    activate: bf("POST account/active"),
    detail: gems("POST user/detail-by-account"),
    register: {
      byEmail: bf("POST account/register/email"),
      check: bf("POST account/register/check")
    }
  },
  password: {
    resetlink: bf("POST account/password/resetlink"),
    reset: bf("POST account/password/reset"),
    verify: gems("POST user/password/verify"),
    update: gems("POST user/password/update")
  },
  articles: {
    list: r("POST articles"),
    comments: r("POST knowledgeArticleRating"),
    viewCount: r("POST knowledgeArticleViewCount")
  },
  contact: r("POST contact"),
  pressnotification: {
    get: r("GET pressnotification")
  },
  leads: {
    create: r("POST leads/create"),
    update: r("POST leads/update"),
    retrieveMembership: gems("GET Leads/retrieveMembership"),
    member: {
      create: r("POST leads/member/create")
    }
  },
  gtm: {
    get: r("GET gtm")
  },
  site: {
    get: r("GET site/{key}"),
    country: r("GET site/country")
  },
  graphql: r1(`POST /api/lynkco-global-portal?sc_apikey=${config.sitecoreApiKey}`, null, config.sitecoreApiHost),
  teamtailor: {
    jobs: r1("GET /v1/jobs?include=department,locations", CONTENT_TYPES.json, config.webSettings?.teamtailor.apiHost, {
      Authorization: `Token token=${config.webSettings?.teamtailor.apiKey}`,
      "X-Api-Version": `${config.webSettings?.teamtailor.apiVersion}`,
      Accept: "application/vnd.api+json"
    })
  },
  auth: {
    publicKey: gems("POST auth/publickey"),
    token: gems("POST auth/token"),
    refresh: gems("GET auth/token/refresh")
  },
  verification: {
    /*Send Verification code to user e-mail*/
    send: gems("POST open/verification/code"),
    email: {
      get: gems("POST open/verification/code"),
      check: gems("POST open/verification/code/check")
    },
    mobile: {
      get: gems("POST open/verification/mobile"),
      check: gems("POST open/verification/mobile/check")
    }
  },
  consent: {
    bind: bf("POST consent/multibind"),
    email: {
      update: gems("POST user/consent/email/update")
    },
    activated: {
      detail: bf("POST consent/activated/detail")
    }
  },
  memebership: {
    list: gems("GET open/memebership/list"),
    price: gems("POST open/memebership/price"),
    category: gems("POST open/memebership/{category}")
  },
  gears: {
    list: r("POST gears")
  },
  product: {
    list: gems("POST product/es"),
    detail: gems("post product/get-spu"),
    recommend: gems("POST product/recommend"),
    sku: {
      get: gems("GET product/{skuId}")
    },
    bundle: {
      list: gems("POST product/bundle/list"),
      detail: gems("GET product/bundle/{bundleId}")
    }
  },
  static: {
    product: {
      list: staticContent("GET {lang}/shop/{page}")
    }
  },
  shoppingCart: {
    merge: gems("POST order/shopping-cart/merge"),
    remove: gems("POST order/shopping-cart/remove"),
    check: gems("POST order/shopping-cart/check")
  },
  store: {
    list: gems("GET open/storelist/{orgId}")
  },
  category: {
    list: { get: gems("GET category/list") },
    id: { get: gems("GET category/{id}") }
  },
  calculation: {
    getProducts: gems("GET calculation/getProducts"),
    multisimulation: gems("POST calculation/multisimulation")
  },
  tradein: {
    save: gems("POST tradein/tradein")
  },
  arvato: {
    token: arvato("POST arvato/auth/token")
  },
  ald: {
    products: arvato("GET ALD/get/products")
  },
  order: {
    save: gems("POST order/save"),
    payment: {
      init: gems("POST order/payment/init"),
      info: gems("POST order/payment/info")
    },
    backup: gems("POST order/backup"),
    pay: gems("POST order/pay"),
    paySantander: gems("POST order/pay/santander/{lang}"),
    detail: gems("GET order/detail/{id}"),
    detailByNo: gems("GET order/detailno/{no}"),
    queryByNoAndEmail: gems("POST order/queryByNoAndEmail"),
    preview: gems("POST order/preview"),
    calculate: gems("POST order/calculate"),
    change: gems("POST order/change"),
    list: gems("POST order/list"),
    latest: {
      index: gems("POST order/latest"),
      specify: gems("POST order/latest/specify")
    },
    getPdf: gems("GET order/receipt-info-pdf/{type}/{pageFormat}/{orderNo}"),
    membership: {
      list: gems("GET order/membership/list")
    },
    receipt: {
      list: gems("POST order/receipt/list"),
      pdf: gems("GET order/receipt/pdf/{orderNo}/{paymentNo}/{pdfCode}/{orgId}/{lang}")
    }
  },
  deliveryMethod: {
    list: gems("GET open/delivery-method/list")
  },
  stock: r("POST stock"),
  spu: {
    deliveryMethod: {
      list: gems("POST open/spu/delivery-method/list")
    }
  },
  open: {
    dictionary: {
      get: gems("POST open/dictionary")
    }
  },
  address: {
    create: gems("POST address/create"),
    update: gems("POST address/update"),
    list: gems("GET address/list"),
    delete: gems("POST address/delete")
  },
  vehicle: {
    order: {
      preview: gems("POST order/preview/vehicle"),
      save: gems("POST order/save/vehicle"),
      loan: {
        finalize: gems("POST order/save/finalize-loan-order")
      }
    },
    stock: {
      lcc: gems("GET order/vehicle/stock/lcc"),
      check: gems("POST order/vehicle/stock/check"),
      save: gems("POST order/save/vehicle")
    }
  },
  touchPoint: {
    list: gems("POST open/touchpoint/list")
  },
  booking: {
    availableTimeSlot: {
      getAll: gems("GET booking/getAvailableSlots"),
      book: gems("POST booking/bookSelectedSlot")
    },
    caseDetail: {
      get: gems("GET booking/getCaseDetail")
    }
  },
  mock: {
    callback: {
      orderNo: gems("GET Mock/callback/reservation/{orderno}")
    }
  },
  mcc: {
    get: gems("POST open/mcc")
  },
  customer: {
    cep: {
      whitelist: gems("GET Customer/cep/customer/{customerNumber}/whitelist")
    }
  }
};
export default api;
